import { render, staticRenderFns } from "./Datatable2.vue?vue&type=template&id=d279a73c&scoped=true&"
import script from "./Datatable2.vue?vue&type=script&lang=js&"
export * from "./Datatable2.vue?vue&type=script&lang=js&"
import style0 from "./Datatable2.vue?vue&type=style&index=0&id=d279a73c&scoped=true&lang=scss&"
import style1 from "./Datatable2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d279a73c",
  null
  
)

export default component.exports